import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Link from '../../shared/Link/Link';
import Button from '../../shared/Button/Button';

import { primary_light } from '../../shared/lib/colors';
import { jsx, css } from '@emotion/core';

import { logoutUser } from '../../../redux/modules/user';
import { setGuestCheckout } from '../../../redux/modules/checkout';

import './Account.scss';

class Account extends Component {
  logoutUser = async () => {
    await this.props.setGuestCheckout(true);
    this.props.logoutUser();
    window.location.reload(true);
  };

  render() {
    const isProfile = this.props.router.isActive('profilo');
    const isOrdini = this.props.router.isActive('ordini');
    const isAccountData = this.props.router.isActive('dati-account');
    const isInvitaUnAmico = this.props.router.isActive('invita-un-amico');
    const isCartaFedelta = this.props.router.isActive('carta-fedelta');

    const {
      primaryColor,
      hasInvitaUnAmico,
      uiVariantButton,
      hasCartaFedelta,
    } = this.props;

    const accountStyle = css`
      .title-with-background,
      h3 {
        background-color: ${primary_light(primaryColor)}!important;
        border-radius: ${uiVariantButton === '1'
          ? '12px'
          : uiVariantButton === '3'
          ? '30px'
          : 0};
      }
      .navigation .nav-pills li {
        &.active {
          a {
            color: ${primaryColor}!important;
          }
        }
        a {
          background-color: transparent !important;
          &:after {
            background-color: transparent !important;
          }
          &:focus,
          &:hover {
            color: ${primaryColor}!important;
          }
        }
      }
    `;

    return (
      <div className="account" css={accountStyle}>
        <div className="container">
          <h1>Gestione account</h1>

          <div className="btn-logout pull-right" onClick={this.logoutUser}>
            <Button className="btn btn-outline btn-thick">Log out</Button>
          </div>

          <nav className="navigation">
            <ul className="nav nav-pills">
              <li
                role="presentation"
                className={'nav-pill' + (isProfile ? ' active' : '')}
              >
                <Link to="/profilo">Profilo</Link>
              </li>
              <li
                role="presentation"
                className={'nav-pill' + (isOrdini ? ' active' : '')}
              >
                <Link to="/ordini">Ordini</Link>
              </li>
              <li
                role="presentation"
                className={'nav-pill' + (isAccountData ? ' active' : '')}
              >
                <Link to="/dati-account">Dati account</Link>
              </li>
              {hasInvitaUnAmico && (
                <li
                  role="presentation"
                  className={'nav-pill' + (isInvitaUnAmico ? ' active' : '')}
                >
                  <Link to="/invita-un-amico">Invita un amico</Link>
                </li>
              )}
              {hasCartaFedelta && (
                <li
                  role="presentation"
                  className={'nav-pill' + (isCartaFedelta ? ' active' : '')}
                >
                  <Link to="/carta-fedelta">Carta Fedeltà</Link>
                </li>
              )}
            </ul>
          </nav>

          {this.props.children}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  primaryColor: state.store.data.loghiTemplate.brandColor,
  hasInvitaUnAmico: state.store.data.features.hasInvitaUnAmico,
  store: state.store.data,
  uiVariantButton: state.store.data.uiVariants.buttons,
  guestCheckout: state.checkout.guestCheckout,
  hasCartaFedelta: state.store.data.features.hasFidelityCard,
});

Account = connect(mapStateToProps, { logoutUser, setGuestCheckout })(Account);

export default withRouter(Account);
